/* RESPONSIBLE TEAM: team-frontend-tech */
import Predicate from 'predicates/models/predicate';
export default Predicate.extend({
  isRoot: true,
  isEditable: false,
  genericType: 'emailDisengagement'
});